import CaseUtil from '@common/lib/caseUtil';
import ProfileShareableApi from '~profile_stats/api/profileShareable';
import { fetchMoonshotLinks } from '@common/utils/moonshot';

const BASE_NAME = 'profile-stats';

// Action Types
const FETCH_PROFILE_STATS_INIT = `${BASE_NAME}/FETCH_PROFILE_STATS_INIT`;
const FETCH_PROFILE_STATS_DONE = `${BASE_NAME}/FETCH_PROFILE_STATS_DONE`;
const FETCH_PROFILE_STATS_ERROR = `${BASE_NAME}/FETCH_PROFILE_STATS_ERROR`;
const ADD_UPLOADED_IMG_URL = `${BASE_NAME}/ADD_UPLOADED_IMG_URL`;
const GET_SOCIAL_LINKS = `${BASE_NAME}/GET_SOCIAL_LINKS`;
const FETCH_SOCIAL_LINKS_INIT = `${BASE_NAME}/FETCH_SOCIAL_LINKS_INIT`;
const FETCH_SOCIAL_LINKS_ERROR = `${BASE_NAME}/FETCH_SOCIAL_LINKS_ERROR`;
const TOGGLE_PROFILE_STATS_CONFIG = `${BASE_NAME}/UPDATE_PROFILE_STATS_CONFIG`;

// Actions
export function getProfileStats() {
  return async (dispatch) => {
    dispatch({ type: FETCH_PROFILE_STATS_INIT });
    try {
      let response = await ProfileShareableApi.getProfileSharableStats();
      response = CaseUtil.toCase('camelCase', response);
      dispatch({
        type: FETCH_PROFILE_STATS_DONE,
        payload: response.profileStats,
      });
    } catch (error) {
      dispatch({ type: FETCH_PROFILE_STATS_ERROR, payload: error });
    }
  };
}

export function toggleStatsConfig(field) {
  return { type: TOGGLE_PROFILE_STATS_CONFIG, payload: field };
}

export function addUploadedImgUrl(url) {
  return async (dispatch) => {
    dispatch({
      type: ADD_UPLOADED_IMG_URL,
      payload: url,
    });
  };
}

export function getSocialLinks() {
  // debugger
  return async (dispatch, getState) => {
    const { statsConfig } = getState().stats.stats;

    dispatch({ type: FETCH_SOCIAL_LINKS_INIT });
    // debugger
    try {
      const json = await ProfileShareableApi.getMoonshotLinks(statsConfig);
      const _links = await fetchMoonshotLinks(json.moonshot_links);
      const shareableLinks = _links;
      // debugger
      dispatch({
        type: GET_SOCIAL_LINKS,
        payload: shareableLinks,
      });
      // debugger
    } catch (_error) {
      dispatch({ type: FETCH_SOCIAL_LINKS_ERROR });
    }
  };
}

const initialState = {
  isLoading: false,
  data: {},
  error: null,
  imgUrl: null,
  socialLinks: null,
  isMoonshotLinkLoading: true,
  statsConfig: {
    avatarLink: false,
    name: true,
    streakCount: true,
    solvedCount: true,
    contestRank: true,
    attendance: true,
  },
};

// Reducer
export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_PROFILE_STATS_INIT:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_PROFILE_STATS_DONE:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case FETCH_PROFILE_STATS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case ADD_UPLOADED_IMG_URL:
      return {
        ...state,
        imgUrl: payload,
      };
    case GET_SOCIAL_LINKS:
      return {
        ...state,
        isMoonshotLinkLoading: false,
        socialLinks: payload,
      };
    case FETCH_SOCIAL_LINKS_INIT:
      return {
        ...state,
        isMoonshotLinkLoading: true,
      };
    case FETCH_SOCIAL_LINKS_ERROR:
      return {
        ...state,
        isMoonshotLinkLoading: false,
      };
    case TOGGLE_PROFILE_STATS_CONFIG:
      return {
        ...state,
        statsConfig: {
          ...state.statsConfig,
          [payload]: !state.statsConfig[payload],
        },
      };
    default:
      return state;
  }
}
